import React from 'react'
import InputField from '../InputField'
import Text from '../Text'
import ProceedButton from './ProceedButton'

const FullName = ({
  name,
  value,
  onChange,
  isLastStep,
  onMoveNext,
  title,
  subtitle,
}) => {
  return (
    <div className="z-10 pt-12 px-4">
      <div className="space-y-3 pb-4">
        <Text
          variant="display"
          size="small"
          className="text-[#101828]"
          tag="h2"
        >
          {title || 'What should we call you?'}
        </Text>
        <Text variant="body" size="medium" className="text-[#475467]" tag="p">
          {subtitle || 'We will refer to you by this name in the application'}
        </Text>
      </div>
      <div className="mt-6">
        <InputField
          name={name}
          label="Full Name"
          type="text"
          placeholder="Enter your full name"
          value={value}
          autoFocus
          onChange={(event) => onChange(name, event.target.value)}
        />
      </div>
      <ProceedButton
        onMoveNext={onMoveNext}
        isLastStep={isLastStep}
        disabled={!value || value.length < 3}
      />
    </div>
  )
}

export default FullName
